import { render, staticRenderFns } from "./Frontpage.vue?vue&type=template&id=86ff7dd2&scoped=true&"
import script from "./Frontpage.vue?vue&type=script&lang=js&"
export * from "./Frontpage.vue?vue&type=script&lang=js&"
import style0 from "./Frontpage.vue?vue&type=style&index=0&id=86ff7dd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ff7dd2",
  null
  
)

export default component.exports